// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * User account lifecycle status.
 */
export enum UserStatus {
  NEW = 0,
  ACTIVE = 1,
  OFFLINE_CREATED = 2,
  OFFLINE_SYNCED = 3,
  OFFLINE_ACTIVE = 4,
  BLOCKED = 5,
  DELETED = 6,
}
